import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface InfoSubjectsProps {
 data: any;
}

const InfoSubjects = (props: InfoSubjectsProps) => {
 const { data } = props;
 const th = useTheme();
 return (
  <Box
   sx={{
    p: 2,
    display: 'flex',
    gap: '12px',
    flexDirection: 'column',
    borderRadius: '4px',
    border: `1px solid ${th.palette.kemek.lightestGray}`,
    mb: 3,
   }}
  >
   <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
    <Box sx={{ fontWeight: 500 }}>{t('results.receiver')}</Box>
    <Box sx={{ textAlign: 'right' }}>
     <Box sx={{ mb: '4px' }}>{data?.Receiver?.Name}</Box>
     <Box sx={{ color: th.palette.kemek.darkGray }}>{data?.Receiver?.Ext}</Box>
    </Box>
   </Box>
   <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
    <Box sx={{ fontWeight: 500 }}>{t('results.sender')}</Box>
    <Box sx={{ textAlign: 'right' }}>
     <Box sx={{ mb: '4px' }}>{data?.Sender?.Name}</Box>
     <Box sx={{ color: th.palette.kemek.darkGray }}>{data?.Sender?.Ext}</Box>
    </Box>
   </Box>
   <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
    <Box sx={{ fontWeight: 500 }}>{t('results.carrier')}</Box>
    <Box sx={{ textAlign: 'right' }}>
     <Box sx={{ mb: '4px' }}>{data?.Carrier?.Name}</Box>
     <Box sx={{ color: th.palette.kemek.darkGray }}>{data?.Carrier?.Ext}</Box>
    </Box>
   </Box>
  </Box>
 );
};

export default InfoSubjects;
